var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "site-header",
      class: { open: _vm.isOpen },
      attrs: { id: "site-header" }
    },
    [
      _c("div", { staticClass: "flex content-max-width" }, [
        _c("a", { staticClass: "logo", attrs: { href: "/home" } }, [
          _c("img", {
            attrs: {
              src: "/images/" + (_vm.isOpen ? "logo-dark.jpg" : "logo.png"),
              alt: "Glasslines"
            }
          })
        ]),
        _vm._v(" "),
        _c("nav", [
          _c(
            "ul",
            { staticClass: "top" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.navigation, function(link, index) {
                return _c("li", { key: index }, [
                  _c("a", { attrs: { href: link.url } }, [
                    _vm._v(_vm._s(link.title))
                  ])
                ])
              }),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm.logged_in
                ? _c(
                    "li",
                    [_c("app-logout-link", { attrs: { csrf: _vm.csrf } })],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm._m(2)
        ]),
        _vm._v(" "),
        _c("a", { staticClass: "tel", attrs: { href: "tel:09-489 6263" } }, [
          _vm._v(_vm._s(_vm.content.phone))
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "email",
            attrs: { href: "mailto:careers@glasslines.co.nz" }
          },
          [_vm._v(_vm._s(_vm.content.email_to))]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "hamburger mobile", on: { click: _vm.toggleMenu } },
          [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "mobile" }, [
      _c("a", { attrs: { href: "/" } }, [_vm._v("Home")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.glasslines.co.nz/about-us",
            target: "_blank"
          }
        },
        [_vm._v("About Us")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex social mobile" }, [
      _c("img", { attrs: { src: "/images/icons/fb.svg", alt: "" } }),
      _vm._v(" "),
      _c("img", { attrs: { src: "/images/icons/ig.svg", alt: "" } })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72144409", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72144409","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Header.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-72144409","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Header.vue
// module chunks = 1